// src/hooks/useCanonicalTag.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { frontend_URL } from '../config/config';

export const useCanonicalTag = () => {
  const location = useLocation();
  
  // Function to generate canonical URL
  const generateCanonicalUrl = (path) => {
    return `${frontend_URL}${path}`;
  };

  useEffect(() => {
    const canonicalUrl = generateCanonicalUrl(location.pathname);
    const canonicalElement = document.querySelector('link[rel="canonical"]');

    if (canonicalElement) {
      canonicalElement.href = canonicalUrl;
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = canonicalUrl;
      document.head.appendChild(link);
    }
  }, [location.pathname]);
};